__turbopack_context__.v({
  "select": "QuestionFormSelect-module__dwrQlq__select",
});
